import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  CircularProgress,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Button,
  Badge,
  Tooltip
} from '@material-ui/core';
import ChatAltIcon from '../../../icons/ChatAlt';
import CreditCardIcon from '../../../icons/CreditCard';
import ShoppingCartIcon from '../../../icons/ShoppingCart';
import helpers from '../../../utils/helpers';

const iconsMap = {
  item_shipped: ShoppingCartIcon,
  new_message: ChatAltIcon,
  order_placed: CreditCardIcon
};

const NotificationList = (props) => {
  const {
    notifications,
    readNotification,
    isEmpty,
    loading,
    skip,
    setSkip,
    currentTab
  } = props;

  return (
    <List disablePadding>
      {
        notifications.length === 0 && (
          <ListItem
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            key="notFound"
          >
            <ListItemText primary="Bildirim bulunamadı" />
          </ListItem>
        )
      }
      {notifications.map((notification) => {
        const Icon = iconsMap[notification.statusType];
        let to = '#';
        if (helpers.notificationToUrl[notification.type]) {
          to = helpers.notificationToUrl[notification.type](notification);
        }
        return (
          <ListItem
            divider
            key={notification.createDate}
            button={!notification.status}
            // sx={{
            //   background: notification.status ? '#FFF' : '#919eab'
            // }}
            onClick={async () => {
              if (!notification.status) {
                await readNotification(notification.id);
              }
            }}
          >
            <ListItemAvatar>
              {
                notification.status ? (
                  <Avatar
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'primary.contrastText'
                    }}
                  >
                    <Icon fontSize="small" />
                  </Avatar>
                ) : (
                  <Badge
                    variant="dot"
                    color="secondary"
                  >
                    <Tooltip title="Okunmamış bildirim">
                      <Avatar
                        sx={{
                          backgroundColor: 'primary.main',
                          color: 'primary.contrastText'
                        }}
                      >
                        <Icon fontSize="small" />
                      </Avatar>
                    </Tooltip>
                  </Badge>
                )
              }
            </ListItemAvatar>
            <ListItemText
              primary={(
                <Link
                  color="textPrimary"
                  sx={{ cursor: 'pointer' }}
                  underline="none"
                  variant="subtitle2"
                  component={RouterLink}
                  to={to}
                >
                  {`${notification.title} ${notification.createdAt}`}
                </Link>
              )}
              secondary={(
                <>
                  <Link
                    color="textPrimary"
                    sx={{ cursor: 'pointer' }}
                    underline="none"
                    variant="subtitle2"
                    component={RouterLink}
                    to={to}
                  >
                    <Typography
                      sx={{ display: 'inline' }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      {notification.description}
                    </Typography>
                  </Link>
                </>
              )}
            />
          </ListItem>
        );
      })}
      {
        !isEmpty[currentTab] && (
          <ListItem
            divider
            button
            key="getmore"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {
              loading ? (<CircularProgress color="primary" />) : (
                <Button
                  type="button"
                  title="Daha fazla göster"
                  onClick={() => {
                    const cloneSkip = { ...skip };
                    cloneSkip[currentTab] += 1;
                    setSkip(cloneSkip);
                  }}
                  variant="contained"
                  color="primary"
                  size="small"
                >
                  Daha fazla göster
                </Button>
              )
            }
          </ListItem>
        )
      }
    </List>
  );
};

export default NotificationList;

NotificationList.propTypes = {
  notifications: PropTypes.array,
  readNotification: PropTypes.func,
  isEmpty: PropTypes.object,
  loading: PropTypes.bool,
  skip: PropTypes.object,
  setSkip: PropTypes.func,
  currentTab: PropTypes.string
};
